/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable no-nested-ternary */
import React, { useState, useContext, useEffect } from 'react';
import {
  AppBar, //
  Box,
  Button,
  TextField,
  Autocomplete,
  Grid, //
  Toolbar, //
  Tooltip,
  IconButton,
} from '@mui/material';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { PassportAuth } from '../../contexts/AuthContext';
import { getStorage } from '../../utils/functions/localstorage';
import {
  useGetMerchantSuperAdminQuery,
  useGetMerchantAllQuery,
} from '../../services/merchant';
import {
  setSelectedCustomerNO,
  setHashTaxIdCustomer,
  setFederalTaxId,
  setSelectCustomerEmail,
} from '../../features/merchant/custNOSlice';
import {
  setSelectedMerchant,
  updateStateMerchants,
} from '../../features/merchant/merchantSlice';
import NotiAlert from '../NotiAlert/NotiAlert';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';

import { decodeJwt } from '../../utils/functions/accessRight'; 
import { ROLES } from '../../utils/constants';

//
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const navShowAllVendor = [
  'pending',
  'approved',
  'rejected',
  'Matching-Main',
  'ReportMatch',
  'ReportUnmatch-Main',
  'Usage-history-login',
  'Usage-history-invoices',
  'Usage-history-creditNote',
  'Usage-history-Upload',
  'Usage-history-Upload',
];

// ✅ เพิ่ม (item || []) กัน Error undefined
const createOptionVendor = (item) =>
  (item || []).map((i) => ({
    ...i,
    label: i.merchant_name,
  }));

// ✅ เพิ่ม (item || []) กัน Error undefined
const createOptionCustomerCode = (item, includeAll = false) => {
  const options = (item || []).map((i) => ({
    ...i,
    label: i.customer_code,
  }));

  return includeAll && options.length > 1
    ? [{ customer_code: 'All', label: 'All' }, ...options]
    : options;
};

function NavbarAllVendor({
  fullPath,
  allVendorOption: [showAllVendorOptions, setShowAllVendorOptions],
  allVendorSelect: [allVendorSelected, setAllVendorSelected],
}) {
  const { data: vendorInfo } = useGetMerchantAllQuery(null, {
    skip: navShowAllVendor.some((value, _) => value === `/${fullPath}`),
  });
  const dispatch = useDispatch();
  const onChangeVendor = (newValue) => {
    const update = {
      allMerchant: newValue ? newValue.sorgcode : null,
    };
    dispatch(updateStateMerchants(update));
    setAllVendorSelected(newValue);
  };

  useEffect(() => {
    // ✅ เช็คให้ชัวร์ว่า vendorInfo และ vendorInfo.data มีค่าจริงๆ
    if (vendorInfo && vendorInfo.data) {
      const { data } = vendorInfo;
      const vendor = createOptionVendor(data);
      setShowAllVendorOptions(vendor);
      setAllVendorSelected(null);
    }
  }, [vendorInfo]);

  
  const responsiveWidth = {
    width: {
      xs: '100%', //
      lg: 250, //
    },
    minWidth: 250, //
  };

  return (
    <>
      <Autocomplete
        id="merchant_name"
        disablePortal
        sx={responsiveWidth} //
        size="small"
        options={showAllVendorOptions}
        defaultValue="All JV"
        value={allVendorSelected}
        isOptionEqualToValue={(option, value) =>
          option.sorgcode === value.sorgcode
        }
        renderInput={(params) => (
          <TextField
            sx={{
              background: '#ffff',
            }}
            {...params}
            placeholder="All"
            label={allVendorSelected ? 'Vendor Company' : ''}
            variant="outlined"
          />
        )}
        onChange={(_, newValue) => onChangeVendor(newValue)}
      />
    </>
  );
}

export default function Navbar({
  openSidebar,
  handleSidebarToggle,
  isMobileNavbarOpen,
  handleMobileNavbarToggle,
}) {
  //
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const toggleLanguage = () => {
    const newLang = lang === 'th' ? 'en' : 'th';
    i18n.changeLanguage(newLang);
  };
  const { handleAdminSignout } = useContext(PassportAuth);
  const userName = getStorage('name');
  
  // เช็คสิทธิ์เพื่อใช้แสดงผลบน Navbar
  const token = getStorage('token');
  const currentRole = token ? (decodeJwt(token).ROLE || decodeJwt(token).role) : '';
  const displayRoleText = currentRole === ROLES.SALE_ROLE ? 'Sale' : 'Super Admin';

  const navigate = useNavigate();
  const [taxId, setTaxId] = useState('');
  const [vendorCompany, setVendorCompany] = useState([]);
  const [vendorSelected, setVendorSelected] = useState(null);
  const [optionCustomerCodes, setOptionCustomerCodes] = useState([]);
  const [customerCodeSelected, setCustomerCodeSelected] = useState(null);

  const [showAllVendorOptions, setShowAllVendorOptions] = useState([]);
  const [allVendorSelected, setAllVendorSelected] = useState(null);
  // Alert -
  const [openAlert, setOpenAlert] = useState(false);
  const [titleAlert, settitleAlert] = useState('');

  const location = useLocation();
  const dispatch = useDispatch();

  const fullPath = location.pathname + location.search;
  const supportsAllCustomers =
    location.pathname === '/' || location.pathname === '/invoice-main';
  const { data: merchantRow, error: merchantRowError } =
    useGetMerchantSuperAdminQuery(taxId, {
      skip: taxId === '',
    });

  const defaultSearching = (data, actionOnchange) => {
    // ✅ ป้องกันกรณี data ว่างเปล่า
    if (!data || data.length === 0) return { vendor: null, customer: null };

    const vendor = createOptionVendor(data);
    // ✅ ป้องกันกรณีไม่มี customers อยู่ใน data[0]
    const customer = createOptionCustomerCode(
      data[0]?.customers || [],
      supportsAllCustomers,
    );

    if (!actionOnchange) setVendorCompany(vendor);
    setVendorSelected(vendor[0] || null);
    setOptionCustomerCodes(customer);
    setCustomerCodeSelected(customer[0] || null);

    return {
      vendor: vendor[0] || {},
      customer: customer[0] || {},
    };
  };

  const setRedux = (data) => {
    // ✅ ป้องกันกรณี data ว่างเปล่า
    if (!data || data.length === 0) return;

    const [firstData] = data;
    // ✅ ป้องกันกรณีไม่มี customers อยู่ใน data[0]
    const [firstCustomer] = createOptionCustomerCode(
      firstData?.customers || [],
      supportsAllCustomers,
    );

    if (firstCustomer) {
      dispatch(setSelectedCustomerNO(firstCustomer.customer_code));
      dispatch(setSelectCustomerEmail(firstCustomer.customer_email));
    }
    if (firstData) {
      dispatch(setHashTaxIdCustomer(firstData.federal_hash_tax_id));
      dispatch(setFederalTaxId(firstData.federal_tax_id));
      dispatch(setSelectedMerchant(firstData.sorgcode));
    }
  };

  const onChangeVendor = (data) => {
    if (!data) return;
    const { vendor, customer } = defaultSearching([data], true);
    
    if (customer && customer.customer_code) {
      dispatch(setSelectedCustomerNO(customer.customer_code));
      dispatch(setSelectCustomerEmail(customer.customer_email));
    }
    if (vendor && vendor.federal_hash_tax_id) {
      dispatch(setHashTaxIdCustomer(vendor.federal_hash_tax_id));
      dispatch(setFederalTaxId(vendor.federal_tax_id));
      dispatch(setSelectedMerchant(vendor.sorgcode));
    }
  };

  const onChangeCustomerCode = (data) => {
    if (data && data.customer_code) {
      dispatch(setSelectedCustomerNO(data.customer_code));
      setCustomerCodeSelected(data);
    }
  };

  const { register, handleSubmit } = useForm();
  const onSubmit = (data) => setTaxId(data.taxId);
  const handleOnCloseAlert = () => setOpenAlert(false);

  useEffect(() => {
    // ✅ เช็คให้ชัวร์ว่ามี data และมีความยาวมากกว่า 0
    if (merchantRow && merchantRow.data && merchantRow.data.length > 0) {
      const { data } = merchantRow;
      defaultSearching(data);
      setRedux(data);
    }
  }, [merchantRow, supportsAllCustomers]);

  useEffect(() => {
    if (merchantRowError) {
      settitleAlert(`ไม่พบเลขที่ผู้เสียภาษี ${taxId}`);
      setOpenAlert(true);
    }
  }, [merchantRowError]);

  const responsiveWidth = {
    width: {
      xs: '100%', //
      lg: 250, //
    },
    minWidth: 250, //
  };

  return (
    <div>
      <NotiAlert
        open={openAlert}
        setOpen={setOpenAlert}
        title={titleAlert}
        value="error"
        onButtonClick={handleOnCloseAlert}
      />

      {/* */}
      <nav
        className={`
          bg-[#f5f5f5]
          border-b border-[#ddd]
          shadow-none
          transition-all duration-300 ease-in-out
        `}
      >
        <div className="flex flex-col xl:flex-row gap-5 p-2 ">
          {/* */}
          <div className="flex xl:hidden ">
            <span className="text-blue-600 font-semibold">{displayRoleText}</span>
            <span className="font-semibold ml-2">{userName}</span>

            <div className="ml-auto flex">
              <div className="hidden md:block">
                <Button
                  color="error"
                  size="small"
                  onClick={() => {
                    handleAdminSignout();
                    navigate('/login-admin');
                  }}
                >
                  <LogoutIcon />
                </Button>
              </div>
            </div>
            <div className="ml-2" onClick={handleSidebarToggle}>
              <MenuIcon />
            </div>
            <div
              className="cursor-pointer ml-2" 
              onClick={handleMobileNavbarToggle}
            >
              {isMobileNavbarOpen ? (
                <ExpandLessIcon /> 
              ) : (
                <ExpandMoreIcon /> 
              )}
            </div>
          </div>
          <div
            className={`
                    ${isMobileNavbarOpen ? 'flex flex-col' : 'hidden'}  
                    xl:flex xl:flex-row xl:flex-1 xl:items-center gap-5 
                  `}
          >
            <div className="flex flex-col xl:flex-row xl:flex-1 xl:flex-wrap items-center gap-5">
              {/* */}
              {fullPath === '/advance-payment' ||
              fullPath === '/waiting-for-payment' ||
              fullPath === '/invoice-main' ||
              fullPath === '/' ||
              fullPath === '/payment-history' ? (
                <>
                  {/* Slot 1: Tax ID Form */}
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <TextField
                        label={t('navbar.taxId')}
                        fullWidth
                        {...register('taxId', { required: true })}
                        sx={{ ...responsiveWidth, background: '#ffff' }}
                        size="small"
                        variant="outlined"
                      />
                    </form>
                  </div>
                  {/* Slot 2: Vendor Autocomplete */}
                  <div>
                    <Autocomplete
                      id="merchant_name"
                      disablePortal
                      disableClearable
                      sx={responsiveWidth}
                      size="small"
                      options={vendorCompany}
                      value={vendorSelected}
                      isOptionEqualToValue={(option, value) =>
                        option.sorgcode === value.sorgcode
                      }
                      disabled={!vendorSelected}
                      renderInput={(params) => (
                        <TextField
                          sx={{
                            background: '#ffff',
                          }}
                          {...params}
                          label={t('navbar.venderCompany')}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, newValue) => onChangeVendor(newValue)}
                    />
                  </div>
                  {/* Slot 3: Customer Autocomplete */}
                  <div>
                    <Autocomplete
                      id="customer_code"
                      disablePortal
                      disableClearable
                      sx={responsiveWidth}
                      size="small"
                      options={optionCustomerCodes}
                      value={customerCodeSelected}
                      isOptionEqualToValue={(option, value) =>
                        option.customer_code === value.customer_code
                      }
                      disabled={!customerCodeSelected}
                      renderInput={(params) => (
                        <TextField
                          sx={{
                            background: '#ffff',
                          }}
                          {...params}
                          label={t('navbar.custNo')}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, newValue) => onChangeCustomerCode(newValue)}
                    />
                  </div>
                </>
              ) : fullPath === '/bill-payment' ||
                fullPath === '/offline-payment' ||
                fullPath === '/user-management' ||
                fullPath === '/settings' ||
                fullPath === '/case' ? (
                <>
                  {/* */}
                  <div style={{ width: 250, display: 'inline-block' }} />
                  <div style={{ width: 250, display: 'inline-block' }} />
                  <div style={{ width: 250, display: 'inline-block' }} />
                </>
              ) : (
                <>
                  {/* Slot 1: NavbarAllVendor */}
                  <div>
                    {' '}
                    <NavbarAllVendor
                      fullPath={fullPath}
                      allVendorOption={[
                        showAllVendorOptions,
                        setShowAllVendorOptions,
                      ]}
                      allVendorSelect={[
                        allVendorSelected,
                        setAllVendorSelected,
                      ]}
                    />
                  </div>
                  {/* */}
                  <div style={{ width: 250, display: 'inline-block' }} />
                  <div style={{ width: 250, display: 'inline-block' }} />
                </>
              )}
            </div>

            <div className="hidden ml-auto xl:flex items-center gap-4">
              <div className="flex flex-col items-end justify-center leading-tight">
                <span className="text-blue-600 text-[11px] font-bold uppercase tracking-wide">
                  {displayRoleText}
                </span>

                <span className="text-gray-800 font-bold text-sm">
                  {userName}
                </span>
              </div>

              <div className="h-8 w-[1px] bg-gray-200 mx-1"></div>

              <div className="flex items-center gap-2">
                <Button
                  onClick={toggleLanguage}
                  size="small"
                  color="primary"
                  style={{ minWidth: 'auto', padding: '4px 8px' }}
                >
                  <LanguageIcon fontSize="small" style={{ marginRight: 4 }} />
                  <span className="font-medium text-sm pt-0.5">
                    {lang === 'th' ? 'TH' : 'EN'}
                  </span>
                </Button>

                <Button
                  color="error"
                  size="small"
                  style={{ minWidth: '40px' }}
                  onClick={() => {
                    handleAdminSignout();
                    navigate('/login-admin');
                  }}
                >
                  <LogoutIcon fontSize="small" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
